export default "__VITE_ASSET__DRT5rQLK__"